export default __webpack_public_path__ + "static/media/expand.fb47dafa.svg";